module.exports = __webpack_public_path__ + "img/Dashboards.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Dashboards.svg
// module id = 247
// module chunks = 0